import { ScrollArea, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewHouseFormValues } from '@e-origin/contracts';

import { EditArray } from '@components';
import { TSDTransportEquipment } from '../../TSDTransportEquipment';

interface HouseTransportProps {
  houseForm: UseFormReturnType<TSDViewHouseFormValues>;
  disabled: boolean;
}

export const HouseTransport: React.FC<HouseTransportProps> = ({ houseForm, disabled }) => {
  return (
    <ScrollArea h="50vh" offsetScrollbars="y">
      <Stack mt="md">
        <Stack mb="sm">
          <Title order={5} fw={600}>
            Transport equipment
          </Title>

          <TSDTransportEquipment form={houseForm} disabled={disabled} />
        </Stack>

        <Stack mb="sm">
          <Title order={5} fw={600}>
            Receptacle
          </Title>

          <EditArray
            addButtonLabel="Add"
            addButtonDataPW="add-receptacle-btn"
            form={houseForm}
            inputs={[
              {
                type: 'Input',
                label: 'Identification number',
                name: 'identificationNumber',
                width: 38,
              },
            ]}
            arrayPath="receptacle"
            disabled={disabled}
            codelistSystemsConfig={{}}
          />
        </Stack>
      </Stack>
    </ScrollArea>
  );
};
